var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-custom-form',{ref:"customForm",attrs:{"noSubBtn":true,"formData":_vm.formData},on:{"sub":_vm.getFormVal}})}
var staticRenderFns = []

export { render, staticRenderFns }